import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import Nav from './nav';
import Main from './main';
import Loading from './loading'
import Login from './login/login'
import Logout from './login/logout'
import Signup from './login/signup'
import Footer from './footer'
import Message from './popups/message'
import Dec from './dec'
import './App.css';
import fire from './config/fire';
import firebase from 'firebase/app';
import 'firebase/firestore';
import userIcon from './pics/svg/user-icon.svg';
import Letters from './letters';
import About from './about';
import Favourites from './favourites';
import Favs from './favs';


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
        }
    }

    componentDidMount(){
      this.authListener();
    }

    loginStyling(user, unsubscribe){
        this.favsListener(unsubscribe);
        let name, photo;
        (user.displayName === null) ? name = user.email : name = user.displayName;
        (user.photoURL === null) ? photo = Letters[name.charAt(0).toUpperCase()] : photo = user.photoURL;
        document.querySelector('.circle.user img').src = photo;
        ReactDOM.render(<Message msg={`hey, ${name}!`} />, document.querySelector('.message-container'));
        document.querySelector('.message').classList.add('appear')
        document.documentElement.style.setProperty("--user-filter", 'unset');
        document.querySelector('.circle.user img').style.width = "var(--circle-size)"
        document.querySelector('.circle.user img').style.height = "var(--circle-size)"
        document.querySelector('.favourites-container span').style.display = "none"
        setTimeout(() => {
            document.querySelector('.message').classList.remove('appear')
        }, 2000);
    }

    logoutStyling(unsubscribe){
        unsubscribe && unsubscribe()
        ReactDOM.render(<Message msg={"Successfully logged out"} />, document.querySelector('.message-container'));
        document.querySelector('.message').classList.add('appear')
        ReactDOM.unmountComponentAtNode(document.querySelector('.favs-container'))
        document.querySelector(".circle.user img").src = userIcon;
        document.documentElement.style.setProperty("--user-filter", 'invert(1)');
        document.querySelector(".circle.user img").style.width = "calc( var(--circle-size) / 2)";
        document.querySelector(".circle.user img").style.height = "calc(var(--circle-size) / 2)";
        document.querySelector('.favourites-container span').style.display = "flex"
        setTimeout(() => {
            document.querySelector('.message').classList.remove('appear')
        }, 2000);
    }

    authListener() {
        let unsubscribe
        fire.auth().onAuthStateChanged(user => {
            (user) ? this.loginStyling(user, unsubscribe) : this.logoutStyling(unsubscribe)
        });
    }

    favsListener(unsubscribe) {
        let user = firebase.auth().currentUser
        
        let db = firebase.firestore(),
        userRef = db.collection('users').doc(user.uid)
        unsubscribe = userRef.onSnapshot(querySnapshot => {

            let favs = querySnapshot.data().favourites
            ReactDOM.render(<Favs favs={favs} />, document.querySelector('.favs-container'));
            favs.forEach(fav => {
                if (fav.countries.length < 1) {
                    document.querySelector(`.fav .info .${fav.id}`).style.display = "none"
                }
            });

        })
        
    }

    render() {
        return (
            <div className="App">
                <div className="message-container"></div>
                <div className="error-container"></div>
                <Nav />
                <Login />
                <About />
                <Favourites />
                <Logout />
                <Signup />
                <Main />
                <Loading />
                <Footer />
                <Dec />
            </div>
        );
    }
}

export default App;
